// components/DualSubtitleDemo.jsx
import React, { useState } from "react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import styles from "../Info.module.css";

const DualSubtitleDemo = () => {
  const [showEn, setShowEn] = useState(true);
  const [showFa, setShowFa] = useState(true);

  return (
    <section className={styles.section} id="features">
      <div className={styles.sectionInner}>
        <Reveal>
          <SectionHeading
            badge="زیرنویس دوگانه"
            badgeColor="teal"
            title="دو زیرنویس همزمان، با کنترل کامل"
            subtitle="زبان مبدأ و ترجمه فارسی رو هم‌زمان ببین — هر کدوم رو که خواستی پنهان کن."
          />
        </Reveal>

        <Reveal delay={100}>
          <div className={styles.dualDemo}>
            <span className={styles.demoHint}>
              امتحان کن! روی آیکون چشم بزن 👇
            </span>

            <div className={styles.demoFrame}>
              <div className={styles.demoScreenGradient}></div>

              <div
                className={`${styles.subtitleRow} ${!showEn ? styles.subtitleRowHidden : ""}`}
                onClick={() => setShowEn((v) => !v)}
              >
                <span className={styles.subtitleLang}>
                  <i className="fas fa-language"></i>
                  EN
                </span>
                <span className={styles.subtitleText}>
                  "You've got more in common with the clown."
                </span>
                <button
                  type="button"
                  className={styles.eyeBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowEn((v) => !v);
                  }}
                  title={showEn ? "پنهان کردن زیرنویس انگلیسی" : "نمایش زیرنویس انگلیسی"}
                >
                  <i className={`fas ${showEn ? "fa-eye" : "fa-eye-slash"}`}></i>
                </button>
              </div>

              <div
                className={`${styles.subtitleRow} ${styles.subtitleRowFa} ${!showFa ? styles.subtitleRowHidden : ""}`}
                onClick={() => setShowFa((v) => !v)}
              >
                <span className={styles.subtitleLang}>
                  <i className="fas fa-language"></i>
                  FA
                </span>
                <span className={styles.subtitleText}>«تو بیشتر با دلقک اشتراک داری.»</span>
                <button
                  type="button"
                  className={styles.eyeBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowFa((v) => !v);
                  }}
                  title={showFa ? "پنهان کردن زیرنویس فارسی" : "نمایش زیرنویس فارسی"}
                >
                  <i className={`fas ${showFa ? "fa-eye" : "fa-eye-slash"}`}></i>
                </button>
              </div>
            </div>

            <p className={styles.demoCaption}>
              دو زیرنویس همزمان، با کنترل کامل — هر کدوم رو خواستی پنهان کن.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default DualSubtitleDemo;